import template from './template.html';
import './styles.css';

controller.$inject = ['$stateParams', '$rootScope', 'DriversService', 'DateService'];
export function controller($stateParams, $rootScope, DriversService,  DateService) {
    let vm = {};
    this.$onInit = function() {
    vm = this;
    const hours = vm.data.allocatedHours || {};
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    vm.days = [
        (hours.sun || 0), (hours.mon || 0), (hours.tue || 0), (hours.wed || 0), (hours.thu || 0), (hours.fri || 0), (hours.sat || 0),
    ];
    
    vm.dayInitials = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    vm.allocatedHours = allocatedHours();
    vm.remainingHours = remainingHours();

    vm.addHoliday = addHoliday;
    vm.deleteHoliday = deleteHoliday;
    vm.controlPropagation = controlPropagation;
    
    initHolidaysArray();
}
    function initHolidaysArray() {
        vm.holidays = [
            (vm.data.allocatedHolidays.sun),  
            (vm.data.allocatedHolidays.mon),  
            (vm.data.allocatedHolidays.tue),  
            (vm.data.allocatedHolidays.wed),  
            (vm.data.allocatedHolidays.thu),  
            (vm.data.allocatedHolidays.fri),  
            (vm.data.allocatedHolidays.sat)  
        ];        
    }

    function allocatedHours() {
        return vm.days.reduce((a, b) => a + b);
    }

    function remainingHours() {
        return vm.data.contractedHours - allocatedHours();
    }

    function addHoliday(dayIndex) {
        if (!vm.isSelected) return;

        //only allow holiday assignment when zero hours assigned for that day
        if (vm.days[dayIndex] === 0) {
            let dateForDay = getDateForDay(dayIndex);
            DriversService.addHoliday(vm.data, dateForDay).then((data) => {
                vm.data.allocatedHolidays[dayNames[dayIndex].toLowerCase()] = true;
                initHolidaysArray();                                    
                $rootScope.$broadcast('holiday-changed'); 
            }).catch((e) => logError(e));
        }
    }

    function deleteHoliday(dayIndex) {
        if (!vm.isSelected) return;

        let dateForDay = getDateForDay(dayIndex);
        DriversService.deleteHoliday(vm.data, dateForDay).then((data) => {
            vm.data.allocatedHolidays[dayNames[dayIndex].toLowerCase()] = false;
            initHolidaysArray();           
            $rootScope.$broadcast('holiday-changed'); 
        }).catch((e) => logError(e));
    }

    function getDateForDay(dayIndex) {
        let date = DateService.getSundayForDate($stateParams.week);
        date.setDate(date.getDate() + dayIndex);
        return date;
    }
    
    function controlPropagation($event) {
        if (vm.isSelected) {
            $event.stopPropagation();
        }
    }
    
    function logError(e) {
        if (console.log) {
            console.log(e);
        }
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        data: '=',
        isSelected: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/driver/index.js